import Storage from '@/utils/Storage'

export const SET_LIVE_AUTH_DATA = (state: any, { authData }: any) => {
    state.liveAuthData = authData
    window.sessionStorage.setItem('authData', JSON.stringify(authData))
}

export const SET_LIVE_SCHEDULED = (state: any, { schedule }: any) => {
    state.liveSchedule = schedule
}

export const SET_EVENT_ACTIONS = (state: any, { actions }: any) => {
    state.eventActions = actions
}

export const SET_SELECTED_ACTION = (state: any, { action }: any) => {
    state.selectedEventAction = action
    window.sessionStorage.setItem('selectedEventAction', JSON.stringify(action))
}

export const SET_LEAD_PAYLOAD = (state: any, { payload }: any) => {
    state.leadPayload = payload
}

export const SET_SUGGESTED_EVENTS = (state: any, { suggestedEvents }: any) => {
    state.suggestedEvents = suggestedEvents
}

export const SET_MY_EVENTS = (state: any, { myEvents }: any) => {
    state.myEvents = myEvents
}

export const SET_UPCOMING_EVENTS = (state: any, { events, totalResultCount }: any) => {
    state.upcomingEvents.events = events
    state.upcomingEvents.totalResultCount = totalResultCount
}

export const SET_PAST_EVENTS = (state: any, { events, totalResultCount }: any) => {
    state.pastEvents.events = events
    state.pastEvents.totalResultCount = totalResultCount
}

export const APPEND_UPCOMING_EVENTS = (state: any, { events, totalResultCount }: any) => {
    state.upcomingEvents.events = [...state.upcomingEvents.events, ...events]
    state.upcomingEvents.totalResultCount = totalResultCount
}

export const APPEND_PAST_EVENTS = (state: any, { events, totalResultCount }: any) => {
    state.pastEvents.events = [...state.pastEvents.events, ...events]
    state.pastEvents.totalResultCount = totalResultCount
}

// export const SET_SEARCHED_EVENT = (state: any, { events, totalResultCount }: any) => {
//     state.searchedEvents.events = events
//     state.searchedEvents.totalResultCount = totalResultCount
// }

export const SET_PHYSICAL_SEARCHED_EVENTS = (state: any, { results, nbResults, currentPage }: any) => {
    state.searchedEvents.physicalEvents.results = results
    state.searchedEvents.physicalEvents.nbResults = nbResults
    state.searchedEvents.physicalEvents.currentPage = currentPage
}

export const SET_PHYSICAL_IN_HUB_SEARCHED_EVENTS = (state: any, { results, nbResults, currentPage }: any) => {
    state.searchedEvents.physicalEventsInHub.results = results
    state.searchedEvents.physicalEventsInHub.nbResults = nbResults
    state.searchedEvents.physicalEventsInHub.currentPage = currentPage
}

export const SET_PHYSICAL_OUT_HUB_SEARCHED_EVENTS = (state: any, { results, nbResults, currentPage }: any) => {
    state.searchedEvents.physicalEventsOutHub.results = results
    state.searchedEvents.physicalEventsOutHub.nbResults = nbResults
    state.searchedEvents.physicalEventsOutHub.currentPage = currentPage
}

export const SET_STREAMING_SEARCHED_EVENTS = (state: any, { results, nbResults, currentPage }: any) => {
    state.searchedEvents.streamingEvents.results = results
    state.searchedEvents.streamingEvents.nbResults = nbResults
    state.searchedEvents.streamingEvents.currentPage = currentPage
}

export const SET_PAST_SEARCHED_EVENTS = (state: any, { results, nbResults, currentPage }: any) => {
    state.searchedEvents.pastEvents.results = results
    state.searchedEvents.pastEvents.nbResults = nbResults
    state.searchedEvents.pastEvents.currentPage = currentPage
}

export const SET_SEARCH_PARAMETERS = (state: any, { searchParameters }: any) => {
    state.searchParameters = searchParameters
}

export const SHOW_SEARCHED_EVENTS = (state: any, { show }: any) => {
    state.showSearchedEvents = show
}

export const RESET_SEARCH_PARAMETERS = (state: any) => {
    state.searchParameters = {
        businessCenters: [],
        city: '',
        startDate: '',
        endDate: '',
        search: '',
        page: 1,
        placeId: '',
    }
}

export const SET_LOADING = (state: any, payload: any) => {
    Object.assign(state.loading, payload)
}

export const ADD_NETWORKING_HISTORY = (state: any, payload: any) => {
    state.networkingHistory.push(payload)
    Storage.set('networkingHistory', state.networkingHistory, 1000 * 60 * 60 * 24) // 1 day
}

export const SET_SEARCH_EVENT_TYPE_FILTER = (state: any, { eventTypeFilter }: any) => {
    state.searchEventTypeFilter = eventTypeFilter
}
